import { useState } from "react";

import { useEditBannerMutation } from "@modules/banners/services/mutations";
import { ActiveBannerSwitchProps } from "./types";

export function useActiveBannerSwitch({ id, value }: ActiveBannerSwitchProps) {
  const [isActive, setIsActive] = useState(value);

  const { mutateAsync, isPending } = useEditBannerMutation(id);

  const toggle = async () => {
    await mutateAsync({
      active: !isActive,
    });

    setIsActive((prev) => !prev);
  }

  return { isActive, isPending, toggle };
}
